import React, { useState } from "react";
import ActionBtn from "../ActionBtn";
import { Icon } from "semantic-ui-react";

export default function DropActionBtn({
  loading,
  // callback,
  label,
  isSecondary,
  isDisabled,
  isFluid,
  isBase,
  isInverted,
  items,
  icon,
}) {
  const [active, setActive] = useState(false);
  return (
    <span
      className="drop-action-btn"
      onMouseEnter={() => setActive(true)}
      onMouseLeave={() => setActive(false)}
    >
      <ActionBtn
        loading={loading}
        icon={icon ?? "triangle down"}
        isSecondary={isSecondary}
        label={label}
        isDisabled={isDisabled}
        isFluid={isFluid}
        isInverted={isInverted}
        isBase={isBase}
      />

      {Array.isArray(items) && items.length > 0 && (
        <div className="options-container">
          <ul className={active ? "active" : "inactive"}>
            {items.map((item, index) => {
              let classList = [];
              if (item.isDisabled) classList.push("disabled");
              return (
                <li key={index}>
                  <button
                    className={classList.join(" ")}
                    onClick={
                      typeof item.callback === "function" &&
                      item.isDisabled !== true
                        ? () => item.callback()
                        : () => null
                    }
                    value={item.value}
                    key={index}
                  >
                    <span className={`action-label`}>
                      {item.icon && (
                        <span className="btn-icon">
                          <Icon name={item.icon} />
                        </span>
                      )}
                      {item.label}
                    </span>
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </span>
  );
}
